<template>
<div class="card-wrapper">
    <div>
        <figure>
            <img :src="cardDetails.IconUrl" alt="" />
        </figure>

        <h3>
            {{ cardDetails.Title }}
        </h3>

        <p>
            {{ cardDetails.Blurb }}
        </p>
    </div>

    <button id="btncard" @click="handleButtonClick()" class="pill-btn blue filled">
        {{ cardDetails.LinkText }}
    </button>
</div>
</template>

<script>
export default {
    name: "ActionCard",
    props: {
        cardDetails: Object,
    },
    methods: {
        handleButtonClick() {
            this.pushGoogleEvent();
            window.location.href = this.cardDetails.DestinationUrl;
        },
        pushGoogleEvent() {
            this.pushEventToGoogleDataLayer(this.cardDetails.GoogleAnalyticsEventCategory, this.cardDetails.GoogleAnalyticsEventAction, this.cardDetails.GoogleAnalyticsEventLabel, this.cardDetails.GoogleAnalyticsEventValue);
        }
    }
};
</script>

<style lang="scss" scoped>
.card-wrapper {
    flex: 0 0 auto;
    max-width: 310px;
    border-radius: 5px;
    box-shadow: 0 0 $spacer-three 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    background-color: $grayscale-eight;
    border-bottom: 5px solid $red;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &>* {
        max-width: 100%;
    }

    figure {
        width: 69px;
        height: 80px;
        margin: auto;
        display: flex;
        align-items: flex-end;

        img {
            display: block;
            padding-bottom: $spacer-three;
        }
    }

    p {
        padding-bottom: $spacer-six;
    }

    h3 {
        line-height: 32px;
    }

    .pill-btn:hover {
        background-color: $blue-dark-hover;
        text-decoration: none;
        color: $grayscale-eight;
    }
}

@include tablet {
    .card-wrapper {
        width: calc(33.3% - 20px);
        margin: 0 $spacer-three;
        padding: $spacer-five $spacer-five 0;

        h3 {
            padding-bottom: $spacer-three;
        }

        .pill-btn {
            width: 170px;
            margin-bottom: $spacer-six;
        }
    }
}

@include wide-mobile {
    .card-wrapper {
        width: 100%;
        padding: $spacer-five $spacer-four 0;

        h1 {
            padding-bottom: $spacer-one;
        }

        h3 {
            padding-bottom: $spacer-two;
        }

        .pill-btn {
            width: 100%;
            margin-bottom: $spacer-four;
        }
    }
}
</style>
